import {post,get} from './request'
//获取分摊类型数组列表
export const shareType = () => {
  let url =  '/supplement/share-type'
    return get(url)
};
//获取外城列表
 export const getBatchList =(data) => {
    // let url= '/supplement/share-type'
    let url= "/supplement/share-type"
    return get(url,data)
 }
 //获取仓库数据
 export const getWarhouseList =() =>{
   let url='/warehouse/staff'
    return get(url)
 }
 //查询渠道 
 export const GetAllChannleList =() =>{
   let url='/system/channel/all'
     return get(url)
 }
 //获取客户数据 
 export const getAllCustomerName =()=>{
   let url= '/customerAll'
      return get(url)
 }
  // 箱数点击详情 
  export const getTrackList =(params)=>{
    let url= '/batch/tracking_number'
    return get(url, params)
  }
  // 偏远邮编API  
   export const farwayZip =(data) =>{
     let url ='/system/channel/createChannelZipCode'
     return post(url,data)
   }
  // 查询已经保存的偏远邮编 
  export const queryDefalutFarwayZip=(params) =>{
    let url='/system/channel/getChannelIdList/' + params + ''
    return get (url)
  }
  //客户单独报价
  export const cusAloneQuote =(data)=>{
    // let url='/separate-quote-order/orderQuote'
    let url= '/separate-quote-order/orderQuote'
    return post(url,data)
  }
  // 客户单独报价
  export const querycusAloneQuote =(param)=>{
    let url ='/price/currentOrderPrice/' + param + ''
    return get(url)
  }



// WEBPACK FOOTER //
// ./src/util/batchAPI.js